import { render, staticRenderFns } from "./PMCollapse.vue?vue&type=template&id=5188a791&"
import script from "./PMCollapse.vue?vue&type=script&lang=ts&"
export * from "./PMCollapse.vue?vue&type=script&lang=ts&"
import style0 from "./PMCollapse.vue?vue&type=style&index=0&id=5188a791&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports